// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VGvb","badges":"styles_badges__3RbHl"};